module.exports = __webpack_public_path__ + "static/media/Personal-license-agreement.bb672194.bin";